window.DocRow = {
    prepareFilterForm: function () {
        Listing.updateLocFilter('salestatsListing');
        var options = {
            success: function (data) {
                DocRow.processFilterForm(data);
            }, dataType: "json"
        };
        MyForm.prepare("salestatsFilterForm", "salestats&action=updateListing", options);

    },
    processFilterForm: function(data){
        Listing.refresh("salestatsListing", data, data.salestats_metadatas);
    },
}
